import { render, staticRenderFns } from "./CabinetHeader.vue?vue&type=template&id=4a50008e&scoped=true&"
import script from "./CabinetHeader.vue?vue&type=script&lang=js&"
export * from "./CabinetHeader.vue?vue&type=script&lang=js&"
import style0 from "./CabinetHeader.vue?vue&type=style&index=0&id=4a50008e&scoped=true&lang=css&"
import style1 from "./CabinetHeader.vue?vue&type=style&index=1&id=4a50008e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50008e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a50008e')) {
      api.createRecord('4a50008e', component.options)
    } else {
      api.reload('4a50008e', component.options)
    }
    module.hot.accept("./CabinetHeader.vue?vue&type=template&id=4a50008e&scoped=true&", function () {
      api.rerender('4a50008e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetHeader.vue"
export default component.exports